import { OrderedStudio } from "entities/studios/types";
import { create } from "zustand";

export type StudioOrderingDataStore = {
  orderedStudios: OrderedStudio[];
  setOrderedStudios: (orderedStudios: OrderedStudio[]) => void;
  clearStudioOrderingData: () => void;
};

export const useStudioOrderingData = create<StudioOrderingDataStore>((set) => ({
  orderedStudios: [],
  setOrderedStudios: (orderedStudios) => set({ orderedStudios }),
  clearStudioOrderingData: () =>
    set({
      orderedStudios: [],
    }),
}));
